import { useTranslation } from 'react-i18next';
import { CasinoGame } from 'types/CasinoGame';
import styles from './VipCasinoBand.module.css';

/** VIP casino pages: the card on top, with the home's slot reels or its
 *  turning roulette wheel. */
export const VipCasinoBand = ({
  live,
  providers,
}: {
  live: boolean;
  providers: { games: CasinoGame[] }[];
}) => {
  const { t } = useTranslation();
  const count = providers.reduce((n, p) => n + (p.games?.length ?? 0), 0);
  return (
    <div className={styles.band} data-vip-dark>
      <span className={styles.glow} />
      <span className={styles.title}>
        {live
          ? `${t('vip_casino_roulette')} · ${t('vip_casino_blackjack')}`
          : t('vip_casino_slots')}
        {count > 0 && (
          <small>{t(live ? 'vip_tables' : 'vip_games', { count })}</small>
        )}
      </span>
      {live ? (
        <>
          <span className={styles.wheel} />
          <span className={styles.orbit}>
            <i />
          </span>
        </>
      ) : (
        <span className={styles.reels}>
          <i>7</i>
          <i>7</i>
          <i>7</i>
        </span>
      )}
    </div>
  );
};
